import React from 'react';
import { CaptchaImage } from '../../../MallSecondAuthPage/style';
import { CapchaQuestion } from '../../DataLinkageRequest/style';
import TextField from 'components/TextField';
import { replaceSpecialCharacter } from 'tools/StringTool';
import StyledActiveButton from 'components/Button/StyledActiveButton';
import GoBackToPrev from '../../GoBackToPrev';
import { MainWrapper } from '../style';
import { useLocation } from 'react-router-dom';

const FillCaptchaFormStep = ({
  mode,
  setStep,
  captchaData,
  setCaptchaData,
  selectedMallData,
  runAccountAuthProcess,
}) => {
  const location = useLocation();
  // 데이터 연동 정보 수정 > 2차인증 정보 변경 > '직접 인증' 선택으로 진입한 케이스
  const isDirectContactStep = location?.state?.step === 'contactStep';

  const { captchaId, captchaValue } = captchaData;

  const { secondAuthUseYn, secondAuthExposureType, secondAuthCategoryCd } =
    selectedMallData;

  // 이전으로 돌아가기 버튼 클릭
  const onClickBackBtn = () => {
    setCaptchaData({});

    const goContactStep =
      secondAuthUseYn === 'Y' &&
      secondAuthCategoryCd === 'SAM100' &&
      (secondAuthExposureType === 'INTERLOCK_ADD_AND_MODIFY' ||
        (secondAuthExposureType === 'INTERLOCK_MODIFY' && mode === 'modify'));

    setStep(goContactStep ? 'contactStep' : 'accountStep');
  };

  // 캡차 인증 입력 필드 수정
  const onChangeCaptchaTextField = event => {
    const value = replaceSpecialCharacter(event.target.value?.trim());
    setCaptchaData(prev => ({ ...prev, captchaValue: value }));
  };

  // 버튼 활성화 검증
  const isDisabledBtn = () => {
    return !captchaId || !captchaValue;
  };

  // 다음 버튼 클릭
  const onClickNextBtn = () => {
    runAccountAuthProcess();
  };

  return (
    <MainWrapper>
      {!isDirectContactStep && <GoBackToPrev onClickReset={onClickBackBtn} />}
      <div className="contentsWrapper">
        <p className="title">
          캡차인증이 발생했어요
          <br />
          <span>자동 등록 방지를 위한 캡차인증을 입력해 주세요</span>
        </p>
        <CaptchaImage src={captchaData.captchaUrl || ''} alt="captchaAuth" />
        {!!captchaData.captchaQuestion ? (
          <>
            <CapchaQuestion>
              질문 : {captchaData.captchaQuestion}
            </CapchaQuestion>
            <TextField
              name="captchaImageCode"
              placeholder="정답을 입력해 주세요."
              value={captchaData.captchaValue || ''}
              onChange={onChangeCaptchaTextField}
            />
          </>
        ) : (
          <TextField
            name="captchaImageCode"
            placeholder="이미지의 문자와 숫자를 입력해 주세요."
            value={captchaData.captchaValue || ''}
            onChange={onChangeCaptchaTextField}
          />
        )}
        <div className="nextBtnBox">
          <StyledActiveButton
            onClick={onClickNextBtn}
            disabled={isDisabledBtn()}
          >
            다음
          </StyledActiveButton>
        </div>
      </div>
    </MainWrapper>
  );
};

export default FillCaptchaFormStep;
